<!--Desktop view start-->
<div
  class="listview-item d-none d-sm-block"
  (click)="onInquiryActionSelect(inquiryActionsEnum.edit)"
>
  <div class="row">
    <div
      baseTruncate
      class="col-3 col-lg-2"
    >
      <span class="fw-bold">{{ inquiry.customerDepartment?.name }}</span>
      <br />
      <span class="d-lg-none main-qualification-text">{{ inquiry.mainQualification?.name }}</span>
    </div>
    <div
      baseTruncate
      class="col-2 d-lg-block d-none main-qualification-text"
    >
      {{ inquiry.mainQualification?.name }}
    </div>
    <div
      baseTruncate
      class="col-2"
    >
      {{ inquiry.dateFrom | baseFormatDate }}
    </div>
    <div class="col-2 col-lg-1">
      <span
        class="badge-booked"
        [ngbTooltip]="tooltip"
        >{{ inquiry.assignmentCount?.all }}</span
      >
      <ng-template #tooltip>
        <div class="p-1">
          <p class="mb-1 text-start font-weight-bolder">{{ 'operations.plural' | translate }}</p>
          <p class="m-0 text-start">
            {{ 'inquiry.occupied' | translate }}: {{ inquiry.assignmentCount?.booked | baseIsEmpty }}
          </p>
          <p class="m-0 text-start">
            {{ 'inquiry.requested' | translate }}: {{ inquiry.assignmentCount?.all | baseIsEmpty }}
          </p>
        </div>
      </ng-template>
    </div>
    <div
      baseTruncate
      class="col-2"
    >
      <span class="fw-bold">{{ inquiry.createdBy?.firstName }} {{ inquiry.createdBy?.lastName }}</span>
      <br />
      <span>{{ inquiry.createdAt | baseFormatDate }}</span>
    </div>
    <div class="col-3">
      <div
        baseTruncate
        *ngIf="!canPublishInquiry"
        class="fw-bold text-danger"
      >
        {{ 'states.' + inquiryStatus[inquiry.status] | translate | uppercase }}
      </div>
      <base-action-dropdown
        *ngIf="canPublishInquiry"
        [items]="inquiryActions"
        [label]="state"
        [color]="color"
        (listItemClicked)="onInquiryActionSelect($event)"
        (click)="$event.stopPropagation()"
      ></base-action-dropdown>
    </div>
  </div>
</div>
<!--Desktop view end-->

<!--Mobile view start-->
<div
  class="collapsable-content arrow-bottom border-top border-light-gray mt-2 py-2 px-0 d-sm-none"
  baseCollapsableContent
  [isFullContentArrow]="true"
  [isInitiallyCollapsed]="true"
>
  <div class="collapsable-header mb-0 p-3">
    <div class="d-flex justify-content-between gap-2 w-100">
      <div
        baseTruncate
        class="col-5 ps-0"
      >
        <span class="fw-bold">{{ inquiry.customerDepartment?.name }}</span>
        <br />
        <span class="main-qualification-text">{{ inquiry.mainQualification?.name }}</span>
      </div>
      <div
        baseTruncate
        class="col-4"
      >
        {{ inquiry.dateFrom | baseFormatDate }}
      </div>
      <div class="col-3 d-flex justify-content-end pe-0">
        <div
          baseTruncate
          *ngIf="!canPublishInquiry"
          class="fw-bold text-danger"
        >
          {{ 'states.' + inquiryStatus[inquiry.status] | translate | uppercase }}
        </div>
        <base-action-dropdown
          *ngIf="canPublishInquiry"
          [items]="inquiryActions"
          [color]="color"
          [iconOnly]="true"
          (listItemClicked)="onInquiryActionSelect($event)"
          (click)="$event.stopPropagation()"
        ></base-action-dropdown>
      </div>
    </div>
  </div>
  <div class="collapsable-body pt-0 px-3 pb-3 mb-3">
    <div class="d-flex justify-content-between gap-2 w-100">
      <div class="col-5">
        <p
          class="fw-bold mb-2"
          baseTruncate
        >
          {{ 'demand' | translate }}
        </p>
        <span class="badge-booked">{{ inquiry.assignmentCount?.all }}</span>
      </div>
      <div class="col-7">
        <p
          class="fw-bold mb-2"
          baseTruncate
        >
          {{ 'inquiry.created' | translate }}
        </p>
        <span
          >{{ inquiry.createdBy?.firstName }} {{ inquiry.createdBy?.lastName }},
          {{ inquiry.createdAt | baseFormatDate }}</span
        >
      </div>
    </div>
  </div>
</div>
<!--Mobile view end-->
